import { ProductLine, ListingKind } from '@kouto/types';
import { NormalizedPublicListing } from 'types/listingV3';
import groupEventDatesByProximity from './groupEventDatesByProximity';

const formatListingsToGroupActivateByDate = (
  listings: NormalizedPublicListing[],
  showMultipleCardsPerEvent: boolean,
  sortByDate = false,
  maxDaysDiffToGroup = 3,
): NormalizedPublicListing[] => {
  const grouped = listings.flatMap((listing) => {
    const availableDates = listing.dates || null;

    if (listing.productLine === ProductLine.ACTIVATE) {
      if (listing.kind === ListingKind.EXPERIENCE) {
        // fix for one time experiences treated as 'activate' listings
        return [
          {
            ...listing,
            dates: availableDates,
          },
        ];
      }

      // normal 'activate' listings
      const groupedDates = groupEventDatesByProximity(
        availableDates,
        maxDaysDiffToGroup,
      );

      return groupedDates
        .slice(0, showMultipleCardsPerEvent ? groupedDates.length : 1)
        .map((dates) => ({
          ...listing,
          dates,
        }));
    }

    return [listing];
  });

  // Only the Activate product page sorts by date; every other surface keeps the
  // order the API returned (which already honors the brand's manual sort).
  if (!sortByDate) {
    return grouped;
  }

  return grouped.sort(
    (a: NormalizedPublicListing, b: NormalizedPublicListing) => {
      // @todo-v3: fix this ?? '' after api change
      const dateA = new Date(a?.dates?.[0] ?? '').getTime();
      const dateB = new Date(b?.dates?.[0] ?? '').getTime();
      return dateA - dateB;
    },
  );
};

export default formatListingsToGroupActivateByDate;
